import React, { useContext, useEffect } from 'react';
import { UIContext } from '../context';
import CollapsedUspModalMobile from './collapsed-usp-modal-mobile';
import { useUspHotspot } from '../hooks/useUspHotspot';
import { connect } from 'react-redux';
import { setIncrementClicked, setDecrementClicked, setToggleHotspotView, setIncrementClickedInterior, setDecrementClickedInterior, setToggleInteriorHotspot, setInteriorHotspotIndex, setHotspotClickedIndex } from '../../../Redux/Reducers/View360Reducer/View360ActionController';

const UspComponentMobile = (props) => {
  const { isExpanded } = useContext(UIContext);
  
  const {
    currentUsp,
    combinedHotspotData,
    handleNextCollapsed,
    handlePrevCollapsed,
    useAutoCycle,
    currentItemType
  } = useUspHotspot(props);

  useAutoCycle(isExpanded);

  const toggleExpand = () => {
    window.parent.postMessage({ 
      type: 'OPEN_HOTSPOT', 
      initialHotspotKey: currentUsp?.key
    }, '*');
  };
  
  return (
    <>
      {combinedHotspotData?.length > 0 && 
        <div className='w-full h-[60px] md:pr-4'>
          <CollapsedUspModalMobile 
            modalList={currentUsp || {}}
            onViewClick={toggleExpand} 
            onNext={handleNextCollapsed}
            onPrev={handlePrevCollapsed}
            currentItemType={currentItemType}
          />
        </div>
      }
    </>
  );
};

const mapStateToProps = (state) => ({
  incrementClicked: state.view360Reducer.incrementClicked,
  decrementClicked: state.view360Reducer.decrementClicked,
  incrementClickedInterior: state.view360Reducer.incrementClickedInterior,
  decrementClickedInterior: state.view360Reducer.decrementClickedInterior,
  toggleInteriorHotspots: state.view360Reducer.toggleInteriorHotspots,
  interiorHotspotIndex: state.view360Reducer.interiorHotspotIndex,
  hotspotClickedIndex: state.view360Reducer.hotspotClickedIndex,
  toggleHotspotView: state.view360Reducer.toggleHotspotView
});

const mapDispatchToProps = {
  setIncrementClicked,
  setDecrementClicked,
  setToggleHotspotView,
  setIncrementClickedInterior,
  setDecrementClickedInterior,
  setToggleInteriorHotspot,
  setInteriorHotspotIndex,
  setHotspotClickedIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(UspComponentMobile); 